unit Reports.Result.Utils;
interface

uses JS;

type

TReportResultUtils = class
  class procedure HandleReportResult(aReportResult: TJSObject);
end;

implementation

uses
  WebLib.Dialogs,
  XData.Web.Client,
  SMX.Web.FileSupport,
  SMX.ReturnTypes,
  system.Rtti,
  SysUtils;

{ TReportResultUtils }

class procedure TReportResultUtils.HandleReportResult(aReportResult: TJSObject);
var
  lOutcome: TResponseOutcome;
  lFileName: string;
begin
  if aReportResult = nil then
  begin
    ShowMessage('Failed to download report');
    Exit;
  end;

  lOutcome := TRttiEnumerationType.GetValue<TResponseOutcome>(JS.toString(aReportResult['Outcome']));

  case lOutcome of
    //    responseOK: ;
    //    responseUpdated: ;
    responseError:
      ShowMessage('Sorry, there was an error trying to create your report. Please contact the GiftAider support team');
    responseException:
      ShowMessage('Sorry, there was an exception trying to create your report. Please contact the GiftAider support team');
    //    responseFileNotFound: ;
    responseNoData: ShowMessage('The query did not return any results.');
  end;

  try
    if lOutcome in [responseOK, responseUpdated] then
    begin
      lFileName := JS.toString(aReportResult['TheFileName']);
      TFileSupport.SaveEncoded64File(lFileName, JS.toString(aReportResult['Data']));
    end;

  except
    on E: Exception do
    begin
      ShowMessage(E.Message);
    end;
  end;
end;

end.
